import { Route } from 'react-router-dom';

import { createLazyRoute } from './utils/createLazyRoute';

/**
 * 결제 관련 라우트
 */
export const paymentRoutes = (
  <Route path="mindd/payment">
    <Route path="manage" {...createLazyRoute(() => import('../pages/payment/PaymentManagePage'))} />
    <Route path="usage" {...createLazyRoute(() => import('./components/UsagePageWrapper'))} />
    <Route path="usage/register" {...createLazyRoute(() => import('./components/UsagePageRegisterWrapper'))} />
    <Route path="settlement" {...createLazyRoute(() => import('../pages/payment/SettlementPage'))} />
  </Route>
);
